import { createFileRoute } from '@tanstack/react-router';
import { EventDetailPage } from '@/modules/events/public';

export const Route = createFileRoute('/_aberto/eventos/$slug')({
  component: function EventRoute() {
    const { slug } = Route.useParams();
    return <EventDetailPage slug={slug} />;
  },
});
